<script setup>
import {originalProfessions, originalCountries, localeProfessions, localeCountries} from '~/assets/jsons/originalParams.json';
import CountryHero from '~/components/country/Hero.vue';
import Statistics from '~/components/country/Statistics.vue';
import Overview from '~/components/country/Overview.vue';
import Areas from '~/components/country/Areas.vue';
import Features from '~/components/country/Features.vue';
import Cta from '~/components/country/Cta.vue';

definePageMeta({
  middleware: 'profession-guard',
}); 

const route = useRoute();
const { profession, country } = route.params;
const { t } = useI18n();


defineI18nRoute({
  paths: {
    tr: '/[profession]/[country]',
    en: '/[profession]/[country]',
    ar: '/مهنة/[profession]/[country]',
  }
})

  const setI18nParams = useSetI18nParams();

  const originalProfession = originalProfessions[profession];
  const originalCountry = originalCountries[country]


  setI18nParams({
    en: { profession: localeProfessions[originalProfession].en, country: localeCountries[originalCountry].en },
    tr: { profession: localeProfessions[originalProfession].tr, country: localeCountries[originalCountry].tr },
    ar: { profession: localeProfessions[originalProfession].ar, country: localeCountries[originalCountry].ar }
  })


useHead(() => ({
  title: t(`lawyerCountries.${originalCountry}.seo.title`),
  meta: [
    { name: 'description', content: t(`lawyerCountries.${originalCountry}.seo.description`) },
    { name: 'keywords', content: t(`lawyerCountries.${originalCountry}.seo.keywords`) },
    { name: 'robots', content: 'index, follow' },
    { property: 'og:title', content: t(`lawyerCountries.${originalCountry}.seo.og.title`) },
    { property: 'og:description', content: t(`lawyerCountries.${originalCountry}.seo.og.description`) },
    { property: 'og:image', content: t(`lawyerCountries.${originalCountry}.seo.og.image`) },
    { property: 'og:url', content: t(`lawyerCountries.${originalCountry}.seo.og.url`) },
  ],
}));



</script>

<template>
  <div>
    <!-- Hero Section -->
    <CountryHero />


    <!-- Statistics Section -->
    <Statistics />

    <!-- Legal System Overview Section -->
    <Overview />

    <!-- Legal Areas Section -->
    <Areas />

    <!-- Features Section -->
    <Features />

    <!-- Testimonials -->
    <!-- <Testimonial /> -->

    <!-- CTA Section -->
    <Cta />
  </div>
</template>


